import React from "react";
import "./Policy.css";

export default function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <h1>Privacy Policy</h1>
      <p>Last updated: August 2025</p>

      <p>
        At TravXplo, your privacy matters to us. This Privacy Policy explains
        how we handle the information you share with us when you use our
        website, tools, and services.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        - Information you provide: name, email, preferences when filling out
        forms or signing up. <br />
        - Usage data: pages visited, features used (e.g., itinerary generator,
        chatbot). <br />
        - Technical details: browser type, device type, cookies for improving
        performance.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use your information only to: <br />
        - Generate personalized itineraries and recommendations. <br />
        - Provide customer support via chat, WhatsApp, or email. <br />
        - Improve our features and user experience. <br />
        - Send updates about your account or services if you opt-in.
      </p>

      <h2>3. Data Protection</h2>
      <p>
        We use secure methods to protect your data. While no system is 100%
        secure, we take reasonable measures to safeguard your personal
        information.
      </p>

      <h2>4. Sharing of Information</h2>
      <p>
        We do not sell or rent your personal data. Information may be shared
        only with trusted partners (like travel booking APIs) necessary to
        deliver our services.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You can request access, correction, or deletion of your data at any
        time. Please email us at <strong>travxplo@gmail.com</strong>.
      </p>
    </div>
  );
}
